<template>
    <b-modal
      id="modal-confirm-action_payment"
      v-model="dialog"
      centered
      hide-header
    >
      <b-card-header class="header-banner">
       
        <div class="d-flex justify-content-between align-items-center block-header">
          <h5 class="mb-0 header-banner-title">
            {{ $t('golf_sidebar_checkout_quick_delete_title')}}
          </h5>
          <feather-icon
            icon="XIcon"
            size="24"
            class="cursor-pointer"
            @click="close"
          />
        </div>
      </b-card-header>
      <b-card-body>
        <b-overlay
          :show="isLoading"
          :opacity="0.3"
          rounded="sm"
        >
        <div class="header-text">
            <span>{{$t('golf_sidebar_checkout_quick_delete_content')}}</span>
        </div>
        <div class="header">
            <div class="header-name">
              {{ getMemberPay() }}
            </div>
            <div class="header-amount">
              {{ totalAmountPaymentBaseCurrDisplay }}
              <ez-icon
              v-if = "!isShowDetailListInvoice"
                click
                style="margin-left: 5px;"
                icon="ezGolf-icon-chevron-down"
                :size="20"
                @click ="showListDetailInvoice"

              />
              <ez-icon
                v-if = "isShowDetailListInvoice"
                style="margin-left: 5px;"
                icon="ezGolf-icon-chevron-up"
                :size="20"
                @click ="showListDetailInvoice"
              />
            </div>
          </div>
          <div 
          class="detail-invoice"  
          ref="refDetaiInvoice"
          v-show ="isShowDetailListInvoice"

          >
            <div class="detail-invoice-item"
              v-for="(payment, index) in listPayment" 
                :key="payment.Id"
          >
           
      <div class=" d-flex justify-content-between">
        <div>
          <span style="display: block;"><strong>{{ index + 1 }}.</strong> {{ getInvoiceText(payment) }} </span>
          <span style="display: block;"> {{ getInvoiceClient(payment) }}</span>
        </div>
        
        <span>{{formatPrice(payment.TotalAmount)  }} </span>
      </div>
          </div>
          </div>
        </b-overlay>
      </b-card-body>
      <template #modal-footer>
          <div>
            <b-button
              variant="primary"
              @click="confirmDialog"
              :disabled ="isLoading"
              class="mr-2"
            >
              {{ $t('golf_common_confirm') }}
            </b-button>
            <b-button
              
              variant="outline-secondary"
              @click="close"
              :disabled ="isLoading"
            >
              {{ $t('golf_common_cancel') }}
            </b-button>
           
          </div>
  
        </template>
    </b-modal>
  </template>
  
  <script>
import { booking } from '@/api/booking'

  export default {
    props:{
        listPayment: {
        type: Array,
    },
    },

    data() {
      return {
        dialog: false,
        item: {
          dataConfirm: {
            title: 'abcass',
            content: 'bsaass',
            hideFooter: false,
          },
        },
        isLoading: false,
        isShowDetailListInvoice:true,
      }
    },
    watch: {
      // dialog(value) {
      //   if(!value) {
      //     this.$emit('cancelDialog', this.item)
      //   }
      // }
    },
    computed: {
    // paymentTypeOptions() {
    //   return [
    //     { title: this.$t('golf_common_payment'), value: PaymentTypeCode.Payment },
    //     { title: this.$t('golf_common_refund'), value: PaymentTypeCode.Refund },
    //   ]
    // },
    getInvoiceText() {
      return (payment) => {
        return `Hóa đơn #${payment.Id} - ${payment.FullName}${payment.BDC ? " #" + payment.BDC : ""}${payment.Bagtag ? " @" + payment.Bagtag : ""}`;
      };
    },
    getInvoiceClient() {
      return (payment) => {
        return `${payment.ClientId ? payment.ClientId +"-" + payment.ClientName : ""}`;
      };
    },
    totalAmountPaymentBaseCurr() {
      if (this.listPayment) {
        return this.listPayment.reduce((sum, item) => sum + (item.TotalAmount ), 0)
      }
      return 0
    },
    totalAmountPaymentBaseCurrDisplay() {
      return `${this.formatPrice(this.totalAmountPaymentBaseCurr)}`
    },
    },
    methods: {
      open(item) {
        this.dialog = true
        this.item = item
      },
      close() {
        this.cancelDialog()
        this.dialog = false
      },
      confirmDialog() {
        this.removeInvoice_and_PaymentDetail_api_DPM09()
        
      },
      cancelDialog() {
        this.dialog = false

      },
      showListDetailInvoice(){
      this.isShowDetailListInvoice = ! this.isShowDetailListInvoice
    },
      getMemberPay() {
      if (this.listPayment) {
        return `${this.$t('golf_sidebar_checkout_list_order')}: ${this.listPayment.length} ${this.$t('golf_payment_invoice')}`
      }
      return ''
    },
    async removeInvoice_and_PaymentDetail_api_DPM09() {
        this.isLoading = true
      const body = {
        PaymentId: this.listPayment.map(item => item.Id),
        IsDeletePaymentDetail: true,
      }
      await booking.api_DPM09(body)
      .then(async response => {
        this.showResToast(response)
        if (response.Status === '200' || (response.Status === '400' && response.Messages[0].Code ==='E.DPM09.C06')) {

          this.dialog = false
          this.$emit('event', { type: 'after-quick_action_delete_payment' })

          // this.$emit('closePopup', true)
        }
      })
      this.isLoading = false
    },
    },
  }
  </script>
  <style lang="scss" >
  #modal-confirm-action_payment {
    .modal-content {
        width: 600px !important;
    }
    .block-header {
      .title-modal {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
      }
    }
    .color-primary {
      color: #114A9F;
    }
  
    .w-50 {
      width: 65px !important;
    }
  
    .color-warning {
      color: #FF9F43;
    }
    .header-text{
        border-bottom: 1px solid rgba(34, 41, 47, 0.05);
        padding-bottom: 0.6rem;
    }
    .header-banner{
        background-color: rgb(255 204 210);
        color: #d22f27 !important;
        .header-banner-title {
            color: #d22f27 !important;
        }
    }
    .header {
            display: flex;
            justify-content: space-between;
            padding-bottom: 1rem;
            font-weight: 500;
            font-size: 14px;
            line-height: 17px;
            padding-top: 0.6rem;
            .header-amount {
               
            }
        }
        .detail-invoice {
            // border-bottom: 1px solid #ddd;
            // padding-bottom: 8px; /* Tạo khoảng cách nhỏ giữa nội dung và border */
            height: 115px;
            overflow-y: auto; /* Bật scroll khi cần */
            .detail-invoice-item {
                font-size: 12px;
                padding-bottom: 5px;
            }
        }
    
  }
  </style>